import { Gender } from '../../../..';
import { genderMapping } from '../../mappings/gender';

export const getGender = <T>(gender?: string, defaultGender?: T): Gender | T => {
    const defaultReturn = typeof defaultGender === 'undefined' ? Gender.NOTPROVIDED : defaultGender;

    if (!gender) {
        return defaultReturn;
    }

    return genderMapping[gender] ?? defaultReturn;
};
